<div class="inputs-wrapper">
  <app-upload-shapefile
    [displayConfig]="{
      showTitle: true,
      showDescription: true,
      titlePosition: 'side',
      titleBold: true,
      customTitle: 'Áreas de Interesse',
      customDescription:
        'Selecione o tipo de arquivo e faça o upload das áreas que deseja analisar',
      showFileTypeSelector: true,
      enabledFileTypes: enabledFileTypes,
      module: 'history',
    }"
    (fileUploaded)="onFileUploaded($event)"
    (originalFileName)="onOriginalFileName($event)"
    (fileTypeChanged)="onFileTypeChanged($event)"
  ></app-upload-shapefile>
  <mat-divider class="divider"></mat-divider>
  <app-file-params-form
    [fileName]="uploadedFileName ?? undefined"
    [originalFileName]="originalFileName ?? undefined"
    [isCarRequired]="selectedFileType === 'spreadsheet'"
    module="history"
  ></app-file-params-form>
  <mat-divider class="divider"></mat-divider>
  <div class="buttons">
    <button mat-stroked-button (click)="navigateToList()">
      <mat-icon>arrow_back</mat-icon>
      Cancelar
    </button>

    <button mat-flat-button (click)="onSubmit()">
      <mat-icon>save</mat-icon>
      Solicitar
    </button>
  </div>
</div>
